import './App.css';
import Header from './components/layout/header/Header';
import Footer from './components/layout/footer/Footer';
import Router from './router';
import ScrollToTop from './components/scrollToTop/ScrollToTop';
import { useStateContext } from './context/StateContext';
import { useAccount } from 'wagmi';
import { useEffect } from 'react';
// import Loader from './components/loader/Loader';
// import { useStateContext } from './context/StateContext';

function App() {

  const account = useAccount()
  const { chainId, setChainId } = useStateContext()

  useEffect(() => {
    setChainId(account.chain?.id)
    localStorage.setItem('chainId', account.chain?.id)
  }, [account, chainId])

  // const { loading } = useStateContext()

  return (
    // <>
    // {loading === true ?
    //   (
    //     <Loader />
    //   ) :
    <div className='w-full max-w-[2140px] mx-auto relative'>
      <Header />
      <style jsx="true">{`
    ::-webkit-scrollbar {
          width: 5px !important;
          background-color: transparent;
        }
        
        ::-webkit-scrollbar-thumb {
          background-color: #fff;
        }
      `}</style>
      <Router />
      <ScrollToTop />
      <Footer />
    </div>
    // }
    // </>
  );
}

export default App;
